import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-brand-card border-t border-brand-border">
      <div className="container-main py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-8">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <img
                src="https://static.readdy.ai/image/c58d2dc5fdc4f4caa90264537c733184/0968609e615b455b3e5560365ff74ad7.png"
                alt="保險門神"
                className="h-8 w-8 object-contain"
              />
              <span className="text-white font-display font-semibold text-[1.0625rem]">
                保險門神
              </span>
            </Link>
            <p className="text-brand-text-secondary text-[1rem] leading-relaxed">
              先守護，再成長。從個人與家庭到企業與傳承，用專業把關每一步。
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold text-[1.0625rem] mb-4">快速導覽</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/about" className="text-brand-text-secondary text-[1rem] hover:text-brand-gold transition-colors">
                  關於保險門神
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-brand-text-secondary text-[1rem] hover:text-brand-gold transition-colors">
                  服務項目
                </Link>
              </li>
              <li>
                <Link to="/testimonials" className="text-brand-text-secondary text-[1rem] hover:text-brand-gold transition-colors">
                  客戶見證
                </Link>
              </li>
              <li>
                <Link to="/insights" className="text-brand-text-secondary text-[1rem] hover:text-brand-gold transition-colors">
                  市場趨勢動態
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-brand-text-secondary text-[1rem] hover:text-brand-gold transition-colors">
                  常見問答
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-brand-text-secondary text-[1rem] hover:text-brand-gold transition-colors">
                  聯絡我們
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-semibold text-[1.0625rem] mb-4">四大守護</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/services/policy" className="text-brand-text-secondary text-[1rem] hover:text-brand-gold transition-colors">
                  保單門神（健診｜整合）
                </Link>
              </li>
              <li>
                <Link to="/services/asset" className="text-brand-text-secondary text-[1rem] hover:text-brand-gold transition-colors">
                  財產門神（資產配置｜風險控管）
                </Link>
              </li>
              <li>
                <Link to="/services/life" className="text-brand-text-secondary text-[1rem] hover:text-brand-gold transition-colors">
                  人生門神（教育金｜退休｜傳承）
                </Link>
              </li>
              <li>
                <Link to="/services/enterprise" className="text-brand-text-secondary text-[1rem] hover:text-brand-gold transition-colors">
                  企業門神（守護企業主的事業）
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold text-[1.0625rem] mb-4">聯絡資訊</h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="https://lin.ee/o51JBHX"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 text-brand-text-secondary text-[1rem] hover:text-brand-gold transition-colors"
                >
                  <span className="w-5 h-5 flex items-center justify-center text-brand-gold">
                    <i className="ri-line-fill" />
                  </span>
                  LINE@：@305fhcxf
                </a>
              </li>
              <li>
                <a
                  href="https://www.facebook.com/profile.php?id=61581854217759"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 text-brand-text-secondary text-[1rem] hover:text-brand-gold transition-colors"
                >
                  <span className="w-5 h-5 flex items-center justify-center text-brand-gold">
                    <i className="ri-facebook-fill" />
                  </span>
                  Facebook
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/nefertari_0122?igsh=c3o2MHVrd3owMTl5"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 text-brand-text-secondary text-[1rem] hover:text-brand-gold transition-colors"
                >
                  <span className="w-5 h-5 flex items-center justify-center text-brand-gold">
                    <i className="ri-instagram-fill" />
                  </span>
                  Instagram
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-6 border-t border-brand-border flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-brand-text-secondary text-[0.9375rem]">
            &copy; 2026 保險門神 Insurance Guardian. All rights reserved.
          </p>
          <p className="text-brand-text-secondary text-[0.9375rem]">
            本網站資訊僅供參考，實際方案以專業諮詢為準
          </p>
        </div>

        {/* Attribution */}
        <div className="mt-4 pt-3 border-t border-brand-border/20 text-center">
          <p className="text-gray-500 text-[0.8125rem]">
            品牌官網建置｜
            <a
              href="https://vpivip.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-brand-gold transition-colors"
            >
              天地人網整合行銷
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
